<template>
  <v-layout align-center justify-center column fill-height>
    <v-dialog v-model="dialog" width="500">
      <v-card v-if="status">
        <v-card-title class="headline" primary-title>
          {{ status.status === 'pending' ? 'You\'re in!' : 'Oops :(' }}
        </v-card-title>

        <v-card-text v-if="status.title === 'Member Exists'">
          It seems you're already registered!
        </v-card-text>
        <v-card-text v-if="status.title === 'Forgotten Email Not Subscribed'">
          It seems you need to confirm your subscription!
          Find the e-mail from us in your inbox.
        </v-card-text>
        <v-card-text v-else-if="isError">
          Unexpected error occured, please try again later :/
        </v-card-text>
        <v-card-text v-else>
          You'll soon receive the newsletter. Don't forget to check your inbox ;)
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="dialog = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-flex xs12 class="bg-blue">

      <!-- Title -->
      <div class="text-xs-center headerTitle  pt-5">
        <p class="display-2">Construct Community</p>
        <p class="display-1 font-weight-light ml-3">Monthly newsletter</p>
      </div>

      <!-- First line -->
      <v-layout
        align-center
        justify-center
        :row="$vuetify.breakpoint.smAndUp"
        :column="$vuetify.breakpoint.smAndDown"
      >
        <v-flex xs6 class="text-xs-center my-5">
          <p class="display-1 pb-3 ">Each month, a newsletter featuring:</p>
          <ul class="d-inline-block  features">
            <li
              class="text-xs-left responsive-font-size">
              <v-icon left>fas fa-fire</v-icon>
              Hot topics on the forums and trending ideas
            </li>
            <li
              class="text-xs-left responsive-font-size">
              <v-icon left>fas fa-laptop</v-icon>
              Tutorials and blog              posts
            </li>
            <li
              class="text-xs-left responsive-font-size">
              <v-icon left>fas fa-cog</v-icon>
               New addons
            </li>
            <li
              class="text-xs-left responsive-font-size">
              <v-icon left>fas fa-gamepad</v-icon>
              Released games, demos              or example
            </li>
            <li
              class="text-xs-left responsive-font-size">
              <v-icon left>fas fa-sync-alt</v-icon>
              Update summaries
            </li>
            <li
              class="text-xs-left responsive-font-size">
              <v-icon left>fas fa-briefcase</v-icon>
              Job offers
            </li>
            <li
              class="text-xs-left responsive-font-size">And maybe even more!
            </li>
          </ul>
        </v-flex>
        <v-flex xs6 class="text-xs-center my-5">
          <h2 class="display-1  mb-3">Register now</h2>
          <v-form ref="form" v-model="valid" lazy-validation class="bg-grey">
            <v-text-field
              v-model="email"
              :rules="emailRules"
              label="E-mail" required></v-text-field>
            <div class="body-1 pb-2">
              Your email will be used for the only purpose
              of this newsletter, no SPAM, no selling adresses
            </div>
            <v-layout>
              <v-spacer></v-spacer>
              <v-btn :disabled="!valid" @click="submit">
                submit
              </v-btn>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>

      <!-- Second line -->
      <v-layout align-center justify-center column>
        <v-flex class="mt-5 text-xs-center hidden-xs-only">
          <v-layout align-center justify-center row>
            <v-flex xs6 class="select-field">
              <v-select
                prefix="Promote or submit "
                solo
                :items="promotionItems"
                v-model="selectedPromotionItem"
                menu-props="auto"
                single-line
                class="centered"
              >
                <v-btn depressed flat slot="append" @click="emailMe">
                  <v-icon left>fas fa-envelope</v-icon>
                  Contact me
                </v-btn>
              </v-select>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex class="mt-4 text-xs-center  big-mb">
          <p class="display-1">Share this newsletter with your friends</p>
          <v-icon class="mx-2" @click="share('email')">
            fas fa-envelope
          </v-icon>
          <v-icon class="mx-2" @click="share('facebook')">
            fab fa-facebook
          </v-icon>
          <v-icon class="mx-2" @click="share('twitter')">
            fab fa-twitter-square
          </v-icon>
        </v-flex>
      </v-layout>

      <!-- Footer -->
      <v-footer absolute class="pa-3  footer">
        <v-layout
          align-center
          justify-space-between
          :row="$vuetify.breakpoint.mdAndUp"
          :column="$vuetify.breakpoint.xsOnly"
          fill-height
        >
          <v-flex xs4 class="text-xs-left">
            <div>We're not related with Scirra</div>
          </v-flex>
          <v-flex xs4 class="text-xs-center">
            <a class="no-underline " href="https://discord.gg/dZDU7Re" target="_blank">
              <v-icon class="mr-2" small left>fab fa-discord</v-icon>
              Join our Discord server</a>
          </v-flex>
          <v-flex xs4 class="text-xs-right">
            <div>
              <a class="" href="https://armaldio.xyz" target="_blank">Armaldio</a> &copy; {{ date === 2018
              ?
              '' : 2018 + ' - ' }}
              {{ date }}
            </div>
          </v-flex>
        </v-layout>
      </v-footer>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    status: null,
    isError: false,
    dialog: false,

    promotionItems: [
      'an Article', 'a Game', 'a Job Offer', 'Other',
    ],
    selectedPromotionItem: 'a Game',

    valid: true,

    email: '',
    emailRules: [
      v => v !== '' || 'You must fill in you e-mail',
    ],
  }),
  computed: {
    date() {
      return new Date().getFullYear();
    },
  },
  methods: {
    emailMe() {
      window.open(`mailto:constructcommunity@armaldio.xyz?subject=Construct%20Community%20-%20${this.selectedPromotionItem}%20submission`, '_blank');
    },
    share(type) {
      switch (type) {
        case 'facebook':
          window.open('https://www.facebook.com/sharer/sharer.php?u=https://ccnewsletter.armaldio.xyz/', '_blank');
          break;
        case 'twitter':
          window.open('https://twitter.com/home?status=Hey!%20Check%20out%20this%20awesome%20newsletter%20about%20Construct%20:)%20via%20@ConstructCommu%0Dhttps://ccnewsletter.armaldio.xyz/', '_blank');
          break;
        case 'email':
          window.open('mailto:?subject=Construct%20Community%20Newsletter&body=Hey!%20Check%20out%20this%20awesome%20newsletter%20about%20Construct%20:)%0Dhttps://ccnewsletter.armaldio.xyz/', '_blank');
          break;
        default:
          break;
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.$http
          .post('/.netlify/functions/subscribe', {
            email_address: this.email,
            status: 'pending',
          }, {
            auth: {
              username: 'armaldio',
              password: '',
            },
          })
          .then((result) => {
            this.status = result.data;
            this.dialog = true;
            this.isError = false;
            console.log('result', result.data);
          })
          .catch((e) => {
            const { response } = e;
            this.status = response;
            this.dialog = true;
            this.isError = true;
            console.error('error', response);
          });
      }
    },
  },
};
</script>

<style>
  .no-underline {
    text-decoration: none;
  }

  .bg-blue {
    position: relative;
    width: 100%;
  }

  .bg-grey {
    margin: 0 auto;
    width: 70%;
    padding: 10px 25px;
    min-height: 185px;
    z-index: 1;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
  }

  .bg-grey:hover {
    box-shadow: 0 19px 38px rgba(0, 0, 0, 0.30), 0 15px 12px rgba(0, 0, 0, 0.22);
  }

  .bg-grey {
    border-radius: 12px;
  }

  .headerTitle {
    padding-top: 25px;
  }

  .footer {
    background-color: #e8e8e8 !important;
  }

  @media screen and (max-width: 600px) {
    .footer {
      height: 95px !important;
    }
  }

  .select-field {
    min-width: 550px;
  }

  .select-field .v-text-field__prefix {
    min-width: 150px;
  }

  .select-field .v-select__selections {
    border-radius: 2px;
    border: 1px solid #ececec;
    padding: 5px 10px;
    min-width: 125px;
    margin: 10px;
  }

  .big-mb {
    margin-bottom: 90px;
  }

  .responsive-font-size {
    font-size: calc(18px + (26 - 18) * ((100vw - 600px) / (1600 - 600)));
  }

  .features {
    list-style-type: none;
  }
</style>
